import { authFetch } from '../utils/authFetch';
import { baseUrl } from '../utils/requestUrl';

export const fetchUserProfile = async () => {
    const userId = JSON.parse(localStorage.getItem('user')).id;
    try {
        const response = await authFetch(`${baseUrl}/user/profile`);
        return response.json();
    } catch (error) {
        console.error('Error fetching user profile:', error);
        throw error;
    }
}
export const updateUserProfile = async (profileData) => {
    const userId = JSON.parse(localStorage.getItem('user')).id;
    try {
        const response = await authFetch(`${baseUrl}/user/profile`, {
            method: 'PATCH',
            body: JSON.stringify(profileData),
         
        });
        return response.json();
    } catch (error) {
        console.error('Error updating user profile:', error);
        throw error;
    }
}
export const getEthnicity = () =>{
    return [
        {
            id: 1,
            name: 'North American Origins'
        },
        {
            id: 2,
            name: 'European origins'
        },
        {
            id: 3,
            name: 'Caribbean origins'
        },
        {
            id: 4,
            name: 'Latin, Central and South American origins'
        },
        {
            id: 5,
            name: 'African origins'
        },
        {
            id: 6,
            name: 'Asian origins'
        },
        {
            id: 7,
            name: 'Oceanian origins'
        },
        {
            id: 8,
            name: 'Other ethnicity and cultural origins'
        }
    ]
}
export const getSex = () =>{
    return [
        {
            id: 1,
            name: 'Male'
        },
        {
            id: 2,
            name: 'Female'
        }
        
    ]
}
export const getGender = () =>{
    return [
        {
            id: 1,
            name: 'Cisgender man'
        },
        {
            id: 2,
            name: 'Cisgender woman'
        },
        {
            id: 3,
            name: 'Transgender man'
        },
        {
            id: 4,
            name: 'Transgender woman'
        },
        {
            id: 5,
            name: 'Non-binary person'
        }
    ]
}
export const getPreferredLanguage = () =>{
    return [
        {
            id: 1,
            name: 'English'
        },
        {
            id: 2,
            name: 'French'
        }
        
    ]
}   